var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"members-menu-story"},[_c('header',{staticClass:"site-header"},[_c('div',{staticClass:"site-header-inner"},[_c('MembersMenu',{attrs:{"user":_vm.user}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }